<ng-container *ngIf="initiateResponseCard">
  <form [action]="initiateResponseCard.acsUrl" method="post" id="acs-form" class="cdk-visually-hidden" hidden target="output_frame">
    <input name="MD" [value]="initiateResponseCard.acsMD" id="MD" hidden>
    <input name="PaReq" [value]="initiateResponseCard.acsPayload" id="PaReq" hidden>
    <input name="TermUrl" [value]="initiateResponseCard.acsTermUrl" id="TermUrl" hidden>
  </form>
</ng-container>
<ng-container *ngIf="showSpinner && !showPaymentMethodError">
  <div class="flex flex-col items-center justify-center h-full">
    <mat-spinner></mat-spinner>
    <p class="mt-4">Please complete your Payment With Apple Pay</p>
  </div>
</ng-container>
<ng-container *ngIf="!showSpinner && paymentCancelled">
  <div class="flex flex-col items-center justify-center h-full text-center">
    <img src="assets/icons/Icons/transaction-fail.png" alt="Error Icon">
    <h2 class="text-xl font-bold mb-2">Payment Method Cancelled</h2>
    <p class="mb-6">Please try again or select another payment method to complete your transaction.</p>
    <p class="mb-4">Or Click the X at the top right to return to cancel the transaction.</p>
  </div>
</ng-container>

<ng-container *ngIf="showPaymentMethodError">
  <div class="flex flex-col items-center justify-center h-full text-center">
    <img src="assets/icons/Icons/transaction-fail.png" alt="Error Icon" >
    <h2 class="text-xl font-bold mb-2">Payment Method Initialization Error</h2>
    <p class="mb-4">We're sorry, but we couldn't initialize Apple Pay at this time.</p>
    <p class="mb-6">Please try another payment method to complete your transaction.</p>
  </div>
</ng-container>

<!--<iframe name="output_frame" src="" [ngClass]="getClasses()" *ngIf="formSubmitted && initiateResponseCard" #output_frame (load)="iframeOnLoad($event)" [ngStyle]="{'height':getIframeHeight()}"></iframe>-->
